import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import ForgotPasswordForm from './index';
import validate from './validate';
import { submit } from '../../actions';

export default compose(
  reduxForm({
    form: 'portalForgotPassword',
    validate,
  }),
  connect(null, { submit })
)(ForgotPasswordForm);
